<template>
  <div class="article-add">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/game-manage' }">游戏管理</el-breadcrumb-item>
      <el-breadcrumb-item>游戏添加</el-breadcrumb-item>
    </el-breadcrumb>


    <div class="game-upload">
      <!-- 游戏名称输入框 -->
      <el-form label-width="120px">
        <el-form-item label="游戏名称">
          <el-input v-model="gameName" placeholder="请输入游戏名称"></el-input>
        </el-form-item>
      </el-form>

      <!-- 游戏数据参数部分 -->
      <div v-for="(param, index) in gameParams" :key="index" class="param-row">
        <el-form label-width="120px">
          <el-form-item label="参数名称">
            <el-input v-model="param.name" placeholder="请输入参数名称"></el-input>
          </el-form-item>
          <el-form-item label="参数类型">
            <el-select v-model="param.type" placeholder="请选择参数类型">
              <el-option label="整形" value="int"></el-option>
              <el-option label="浮点" value="float"></el-option>
              <el-option label="字符串" value="str"></el-option>
              <el-option label="列表" value="list"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参数说明">
            <el-input v-model="param.description" placeholder="请输入参数说明"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="danger" icon="el-icon-delete" @click="removeParam(index)">
          删除参数
        </el-button>
      </div>

      <!-- 添加参数按钮 -->
      <div class="button_con">
        <el-button type="primary" @click="addParam">添加参数</el-button>
        <el-button type="primary" @click="saveData">确定</el-button>
      </div>

    </div>

  </div>
</template>


<script>


export default {

  data() {
    return {
      gameName: '',
      gameParams: [
        // 初始的游戏数据参数
        {
          name: '',
          type: '',
          description: '',
        },
      ],
      listNumber:0,
      StrNumber:0,
      FloatNumber:0,
      IntNumber:0
    }
  },
  methods:{
    addParam() {
      // 添加一个新的游戏数据参数
      if (!this.gameName) {
        this.$message.error('请先添加游戏名称');
        return;
      }
      // 遍历游戏参数数组，检查是否有未输入的参数
      for (const param of this.gameParams) {
        if (!param.name || !param.type || !param.description) {
          this.$message.error('请填写完整的参数信息');
          return;
        }
      }

      if (this.gameParams.length === 1) {
        const prevParameter = this.gameParams[this.gameParams.length - 1];
        const isEnglish = /^[a-zA-Z]+$/.test(prevParameter.name);

        const isNotChinese=this.containsChineseCharacters(prevParameter.description)
        console.log(isNotChinese)
        if (isEnglish &&isNotChinese) {
          this.gameParams.push({ name: "", type: "", description: "" });
        } else {
          this.$message.error("参数名称必须为英文或参数说明必须为中文");
        }

        // this.gameParams.push({ name: "", type: "", description: "" });
        return;
      }

      const prevParameter = this.gameParams[this.gameParams.length - 1];
      const LastMeter = this.gameParams[this.gameParams.length - 2];
      // 在这里进行验证
      // 验证参数名称是否为英文且不重复
      const isEnglish = /^[a-zA-Z]+$/.test(prevParameter.name);
      // console.log(this.gameParams)
      const isNotDuplicate = prevParameter.name===LastMeter.name
      const isNotChinese=this.containsChineseCharacters(prevParameter.description)
      console.log(isNotChinese)
      if (isEnglish && !isNotDuplicate&&isNotChinese) {
        this.gameParams.push({ name: "", type: "", description: "" });
      } else {
        this.$message.error("参数名称必须为英文或不能与上一个参数重复或参数说明必须为中文");
      }
    },


    removeParam(index) {
      // 移除指定位置的游戏数据参数
      this.gameParams.splice(index, 1);
    },
    getFirstLetterUpperCase(str) {
      // 检查输入字符串是否为空
      if (str.length === 0) {
        return "";
      }

      // 提取字符串的第一个字符并转换为大写字母
      return str.charAt(0).toUpperCase();
    },
    goOff(){
      // 重置游戏名称和其他输入字段
      this.gameName = '';

      // 清空游戏参数数组
      this.gameParams = [
        {
          name: '',
          type: '',
          description: '',
        },
      ];

      // 重置其他数据
      this.listNumber = 0;
      this.StrNumber = 0;
      this.FloatNumber = 0;
      this.IntNumber = 0;
    },
    containsChineseCharacters(str) {
      // 使用正则表达式匹配中文字符
      const pattern = /[\u4e00-\u9fa5]/;
      return pattern.test(str);
    },
    saveData() {
      // 游戏名称
      if (!this.gameName) {
        this.$message.error('请先添加游戏名称');
        return;
      }
      for (const param of this.gameParams) {
        if (!param.name || !param.type || !param.description) {
          this.$message.error('请填写完整的参数信息');
          return;
        }
      }
      const gameName = this.gameName;

      // 游戏参数说明和类型的数据结构
      const gamePagesCHN = {};
      const gamePages = {};

      // 遍历游戏参数数组，整理数据
      this.gameParams.forEach((param, index) => {
        if (param.name && param.type && param.description) {
          // let FistName=this.getFirstLetterUpperCase(param.type)
          // 使用 `keyS01`, `keyI01`, `keyF01` 等格式作为参数名称
          // const key = `key${index < 10 ? '0' +FistName + index+1 : index}`;

          // 记录参数说明到 gamePagesCHN
          gamePagesCHN[param.name] = param.description;
          let AddName=''
          let FistName=this.getFirstLetterUpperCase(param.type)
          // 记录参数类型到 gamePages
          switch (param.type){
            case "str":{
              this.StrNumber++;
              AddName=`key${  this.StrNumber < 10 ? FistName+'0' +this.StrNumber:FistName+this.StrNumber}`
              break;
            }
            case "int":{
              this.IntNumber++;
              AddName=`key${  this.IntNumber < 10 ? FistName+'0' +this.IntNumber:FistName+this.IntNumber}`
              break;
            }
            case "float":{
              this.FloatNumber++;
              AddName=`key${  this.FloatNumber < 10 ? FistName+'0' +this.FloatNumber:FistName+this.FloatNumber}`
              break;
            }
            case "list":{
              this.listNumber++;
              AddName=`key${  this.listNumber < 10 ? FistName+'0' +this.listNumber:FistName+this.listNumber}`
              break;
            }
          }
          gamePages[param.name] = AddName
        }
      });

      // 构建最终的数据对象
      const data = {
        name: gameName,
        game_pages_CHN: gamePagesCHN,
        game_pages: gamePages,
      };
      this.goOff()
      this.$post('v1/admin/game-name-all',data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.goOff()
            // this.previewImage=res.data.data.qrcode_url
            this.$message.success('上传成功');
          } else {
            this.$msg(res.data.msg)
          }
        });
      // 输出数据对象
      console.log(data);
      // 这里你可以将 data 发送到后端或者按照你的需求进行处理
    },
  },


  created() {
    // this.getVariety()
  }

}
</script>


<style scoped>
.game-upload {
  padding: 20px;
}

.param-row {
  margin-bottom: 20px;
  border: 1px solid #ccc;
  padding: 20px;
  position: relative;
}
.el-input{
  width: 80%;
}
.button_con{
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 50px; /* 父元素高度 */
  /*background-color: lightgray; !* 为了看清楚父元素的位置 *!*/
}
.param-row .el-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/GameManage/AddGame.vue